export const CONDITION_GROUP_OPTIONS = [
  { label: 'Always', value: '' },
  { label: 'FS', value: 'FleetFs' },
  { label: 'Not FS', value: 'NotFleetFs' },
  {
    label: 'Require sub-customer approval',
    value: 'NeedSubCustomerApproval',
  },
  {
    label: 'Not require sub-customer approval',
    value: 'NoSubCustomerApproval',
  },
] as const;

export const getConditionGroupLabel = (conditionGroup: string) =>
  CONDITION_GROUP_OPTIONS.find((option) => option.value === conditionGroup)
    ?.label ?? conditionGroup;
